import React from "react";
import { useAddress } from "@thirdweb-dev/react";
import { useTranslation } from "react-i18next";
import "../styles/vesting-box2.css";
import { useVestingContract } from "../hooks/useVestingContract";

const VestingBox2 = () => {
  const { t } = useTranslation();
  const address = useAddress();
  const { 
    hasVesting, 
    vestingInfo, 
    formatDate, 
    unlockedTokens,
    isLoading 
  } = useVestingContract();

  const formatAmountWithCommas = (amount) => {
    if (!amount) return "0";
    return parseFloat(amount).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  // Calcular cuánto tiempo falta para la próxima liberación
  const getTimeUntilNextRelease = () => {
    if (!vestingInfo || !vestingInfo.nextUnlock) return t('vestingBox2.notScheduled');
    
    const now = new Date();
    const nextUnlock = vestingInfo.nextUnlock;
    
    if (now >= nextUnlock) return t('vestingBox2.availableNow');
    
    const diffMs = nextUnlock - now;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const diffHrs = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    
    if (diffDays > 0) {
      return `${diffDays} ${t('vestingBox2.days')} ${diffHrs} ${t('vestingBox2.hours')}`;
    }
    
    const diffMins = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    return `${diffHrs} ${t('vestingBox2.hours')} ${diffMins} ${t('vestingBox2.minutes')}`;
  };

  // Calcular próxima cantidad a liberar (1% del total)
  const getNextReleaseAmount = () => {
    if (!vestingInfo || !vestingInfo.totalAmount) return "0";
    
    // 1% del total asignado
    const nextAmount = parseFloat(vestingInfo.totalAmount) / 100;
    return formatAmountWithCommas(nextAmount);
  };

  return (
    <div className="vesting-box">
      <div className="box-content">
        <div>
          <h4>{t('vestingBox2.nextRelease')}</h4>
          <p className="value">
            {!address ? "-" : 
             !hasVesting ? t('vestingBox2.noVesting') : 
             isLoading ? t('vestingBox2.loading') : 
             vestingInfo && vestingInfo.nextUnlock ? formatDate(vestingInfo.nextUnlock) : t('vestingBox2.notScheduled')}
          </p>
          {address && hasVesting && !isLoading && vestingInfo && vestingInfo.nextUnlock && (
            <p className="time-remaining">{getTimeUntilNextRelease()}</p>
          )}
        </div>
        <div>
          <h4>{t('vestingBox2.amountToRelease')}</h4>
          <p className="value">
            {!address ? "0" : 
             !hasVesting ? "0" : 
             isLoading ? t('vestingBox2.loading') : getNextReleaseAmount()}
            <span className="unit green-text">$eDOP</span>
          </p>
        </div>
      </div>
      
      <button 
        id="unlock-tokens" 
        disabled={!address || !hasVesting || parseFloat(unlockedTokens) <= 0}
      >
        {t('vestingBox2.claimAvailableTokens')}
      </button>
    </div>
  );
};

export default VestingBox2;
